import { createStore } from 'vuex';

import user from './modules/userManagement';
import alert from './modules/alert';
import layout from './modules/layout';
import menu from './modules/menu';

export default createStore({
  state: { isActive: false },
  getters: {},
  mutations: {
    change(state) {
      state.isActive = !state.isActive;
    },
  },
  actions: {},
  modules: {
    user,
    alert,
    layout,
    menu
  },
});
